import axios from "axios";

const URL = process.env.REACT_APP_BASE_URL;

//Api for send email
export const sendEmail = async (data) => {
  try {
    const response = await axios.post(`${URL}send_email`, data);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};